import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { PageSchema } from '@/components/SEOSchema';
import { SITE_URL } from '@/lib/seo';

export default function ContactPage() {
  const { t, i18n } = useTranslation();
  const homePath = i18n.language === 'pt' ? '/' : `/${i18n.language}/`;
  const contactUrl = `${SITE_URL}${i18n.language === 'pt' ? '/contact/' : i18n.language === 'de' ? '/de/kontakt/' : '/en/contact/'}`;

  return (
    <div className="min-h-screen bg-background-50">
      <PageSchema
        type="ContactPage"
        name={t('nav.contact')}
        description="Contact the CSSBuy Spreadsheet Resource Hub for questions, suggestions and information about the CSSBuy Spreadsheet."
        url={contactUrl}
        lang={i18n.language}
      />
      <Navbar />

      <div className="w-full px-4 md:px-6 lg:px-10 pt-24 pb-16">
        <div className="max-w-3xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
            <Link to={homePath} className="hover:text-primary-600 transition-colors">{t('nav.home')}</Link>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-600">{t('nav.contact')}</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-semibold mb-8">{t('nav.contact')}</h1>

          <p className="text-foreground-600 leading-relaxed mb-8">
            Para dúvidas, sugestões ou informações sobre o CSSBuy Spreadsheet, entre em contato. Responderemos o mais breve possível.
          </p>

          <div className="bg-white border border-background-200/60 rounded-xl p-6 md:p-8">
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-600" />
                </div>
                <div>
                  <p className="font-medium text-sm">Email</p>
                  <p className="text-sm text-foreground-500">contact@cssbuybr.sbs</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-accent-50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-line text-accent-600" />
                </div>
                <div>
                  <p className="font-medium text-sm">Website</p>
                  <a href="https://cssbuybr.sbs" className="text-sm text-primary-600 hover:underline">cssbuybr.sbs</a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-lg bg-secondary-50 flex items-center justify-center flex-shrink-0">
                  <i className="ri-external-link-line text-secondary-600" />
                </div>
                <div>
                  <p className="font-medium text-sm">Main Website</p>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-primary-600 hover:underline">kaspreadsheet.com</a>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 bg-foreground-50 border border-foreground-200/50 rounded-xl p-5">
            <p className="text-sm text-foreground-500 italic">
              {t('about.disclaimerText')}
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}